import { authenticatedDownload } from "@app/shared/AuthenticatedDownload";
import { FC } from "react";
import DragAndDropFileUploader from "@app/shared/DragAndDropFileUploader";
import PageSection from "@app/shared/PageSection";
import { QESButton } from "@app/shared/qes-standards/Button";
import { UploadTagsWizardStepProps } from "@app/tags/import/types";

const UploadTagsWizardImportList: FC<UploadTagsWizardStepProps> = (props: UploadTagsWizardStepProps) => {
  const helpFileUri = `${window.apiEndpointV2_0}/resourcetagging/uploadtagssamplefile`;
  const uploadObjectKey = "tagsFile";

  const downloadSampleFile = () => {
    authenticatedDownload(helpFileUri, undefined);
  }

  return (
    <PageSection>
      <div className="container">
        <p className="mt-3">
          Select the file you want to upload. The data must be in a CSV file. Or upload a file with the&nbsp;
          <QESButton
            qesType="secondary"
            className="bg-transparent p-0"
            qesTestId="upload-tags-wizard-import-list__sample-file"
            onClick={downloadSampleFile}
          >
            correct format
          </QESButton>.
        </p>
        <DragAndDropFileUploader
          apiKeyName={uploadObjectKey}
          onUpload={props.handleUpload}
          filetype=".csv"
          hasBeenSuccessful={props.wasSuccessful}
          testId="upload-tags-wizard-import-list__file-input"
        />
      </div>
    </PageSection>
  );
}

export default UploadTagsWizardImportList;
